import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-search-dialog',
  templateUrl: './delete-search-dialog.component.html',
  styleUrls: ['./delete-search-dialog.component.scss']
})
export class DeleteSearchDialogComponent implements OnInit {

  message: string;

  constructor(
    public dialogRef: MatDialogRef<string>,
    @Inject(MAT_DIALOG_DATA) public data: string
    ) { }

  ngOnInit(): void {
    this.message = `Sei sicuro di voler eliminare la ricerca ${this.data}?`;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

}
